export const DYNAMIC_CONTENT_PAGE_SEO_TO_FOLDER_MAPPING:Record<string,string> = {
    "gaming-blog":"Gaming-blog",
    "over-ons":"Over ons",
    "blog":"blog",
    "klantenservice":"Klantenservice"
}

export const DYNAMIC_CONTENT_PAGE_FOLDER_TO_SEO_MAPPING:Record<string,string> = {
    "gaming-blog":"gaming-blog",
    "over ons":"over-ons",
    "blog":"blog",
    "klantenservice":"klantenservice"
}

export const DYNAMIC_CONTENT_PARENT_PAGE_SEO_URL:Record<string,string> = {
    "gaming-blog":"gaming-blog-overzicht",
    "over ons":"over-ons-overzicht",
    "blog":"blog-overzicht",
    "klantenservice":"klantenservice-overzicht"
}

export const ALLOWED_CANONICAL_STATIC_ROUTES = ['winkel-zoeken'];